import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_PAYROLL_REPORT } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const payrollReport = {
  namespaced: true,
  state: buildInitialState({
    payrollReport: [
      {
        payrollSummaries: [],
        dateBegin: null,
        dateEnd: null,
        invoiceFrequencyId: null,
        totalRevenue: null
      }
    ]
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearPayrollReport: (state) => {
      state.payrollReport = [
        {
          payrollSummaries: [],
          dateBegin: null,
          dateEnd: null,
          invoiceFrequencyId: null,
          totalRevenue: null
        }
      ]
    },
    setPayrollReport: (state, payrollReport) => {
      state.payrollReport = payrollReport
    }
  },
  actions: {
    getPayrollReport: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting payroll data, please wait...' })

      return api.doGet({ path: PATH_PAYROLL_REPORT, parameters: filters })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          commit('setPayrollReport', data)
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get payroll data')
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getPayrollReportWithFilters: ({ dispatch, rootGetters }) => {
      return dispatch('getPayrollReport', { ...rootGetters['payrollReportFilters/getSearchObject'] })
    },
    clearPayrollReport ({ commit }) {
      commit('clearPayrollReport')
    }
  }
}

export default payrollReport
